import React from "react";
import DefaultSubscribeForm from "components/DefaultSubscribeForm/DefaultSubscribeForm";

interface RequestBrochureModalFormProps {
  onSubmitSuccess: () => void;
  brochureCode: string;
}

const RequestBrochureModalForm: React.FC<RequestBrochureModalFormProps> = ({
  onSubmitSuccess,
  brochureCode
}) => {
  return (
    <DefaultSubscribeForm
      formName="RequestBrochureForm"
      onSubmitSuccess={onSubmitSuccess}
      requestSource="EBRO"
      requestType="RAB"
      enableSubscribeEmail={true}
      askImNotTraveAgent={true}
      askWorkWithAgent={true}
      askPhone={true}
      brochureCode={brochureCode}
      dataContentName="rab_form"
    />
  );
};

export default RequestBrochureModalForm;
